// extracted by css-extract-rspack-plugin
export default {"highlight":"tQ6_Wd1Fcx9kz0zC__highlight___","mention":"dQMlc46bwsFxTxjg__mention___","mentionDeactivated":"Y3uTW6lD_W4BB0SS__mentionDeactivated___"};